// extracted by mini-css-extract-plugin
export default {"inputContainer":"PhoneNumberInput_inputContainer__sQ9Iz","input":"PhoneNumberInput_input__2fQdU","label":"PhoneNumberInput_label__WopSr","error":"PhoneNumberInput_error__gWKVe"};